import { Text } from "@mantine/core";
import { observer } from "mobx-react-lite";
import { Cubby } from "../../stores/Cubby";
import React from "react";
import { convertSatsToFiatString } from "../../helpers/conversions";

const SatoshisInfo = observer(
  ({ cubby, satoshis }: { cubby: Cubby; satoshis: number }) => {
    // Show nothing if satoshis is 0, null, or NaN
    if (!satoshis || isNaN(satoshis)) {
      return null;
    }

    // Calculate BTC and USD value and display
    const btcValue = (satoshis / 100_000_000).toFixed(8); // Convert sats to BTC
    const fiatValue = convertSatsToFiatString(satoshis, cubby, true);

    return (
      <Text span mt={"-.7rem"} size="xs" c="dimmed">
        {btcValue} BTC / {fiatValue}
      </Text>
    );
  }
);

export default SatoshisInfo;
